(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('chp-{{ section.id }}');
  if(!root) return;

  // Init alle Carousels (mobile & desktop separat)
  const wraps = root.querySelectorAll('.chp__wrap.is-carousel');
  wraps.forEach((wrap) => {
    const viewport = wrap.querySelector('.chp__viewport');
    const track = wrap.querySelector('.chp__track');
    const arrows = wrap.querySelectorAll('.chp__arrow');
    const dotsWrap = wrap.querySelector('.chp__dots');

    if(!viewport || !track) return;

    function buildDots(){
      if(!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const count = track.children.length;
      for(let i=0;i<count;i++){
        const dot = document.createElement('button');
        dot.className = 'chp__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Seite ${i+1}`);
        dot.addEventListener('click', () => {
          viewport.scrollTo({ left: i * viewport.clientWidth, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }
    function updateDots(){
      if(!dotsWrap) return;
      const page = Math.round(viewport.scrollLeft / viewport.clientWidth);
      [...dotsWrap.children].forEach((el,i)=> el.setAttribute('aria-current', i===page ? 'true':'false'));
    }

    function atStart(){ return viewport.scrollLeft <= 2; }
    function atEnd(){ const max = track.scrollWidth - viewport.clientWidth; return (max - viewport.scrollLeft) <= 2; }
    const loop = viewport.getAttribute('data-loop') === 'true';

    function go(dir){
      if(dir>0){
        if(atEnd()){ if(loop) viewport.scrollTo({ left: 0, behavior:'smooth' }); }
        else viewport.scrollBy({ left: viewport.clientWidth, behavior:'smooth' });
      }else{
        if(atStart()){
          if(loop){
            const max = track.scrollWidth - viewport.clientWidth;
            viewport.scrollTo({ left: max, behavior:'smooth' });
          }
        } else {
          viewport.scrollBy({ left: -viewport.clientWidth, behavior:'smooth' });
        }
      }
    }

    arrows.forEach(btn=>{
      btn.addEventListener('click', ()=>{
        stopAutoplay();
        const dir = parseInt(btn.getAttribute('data-dir'),10);
        go(dir);
        startAutoplay();
      });
    });

    viewport.addEventListener('scroll', ()=> window.requestAnimationFrame(updateDots));

    // Autoplay pro Wrap
    const delay = parseInt(viewport.getAttribute('data-autoplay') || '0', 10);
    const pauseOnHover = viewport.getAttribute('data-pause-hover') === 'true';
    let timer = null;

    function tick(){ go(1); }
    function startAutoplay(){ if(!delay) return; stopAutoplay(); timer = setInterval(tick, delay); }
    function stopAutoplay(){ if(timer){ clearInterval(timer); timer = null; } }

    startAutoplay();
    if(pauseOnHover){
      viewport.addEventListener('mouseenter', stopAutoplay);
      viewport.addEventListener('mouseleave', startAutoplay);
      viewport.addEventListener('focusin', stopAutoplay);
      viewport.addEventListener('focusout', startAutoplay);
    }

    let rT; window.addEventListener('resize', ()=>{ clearTimeout(rT); rT=setTimeout(buildDots,120); });
    buildDots();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // Update data-cart-empty attribute when cart status changes
  function updateCartIconVisibility() {
    const cartIcon = document.querySelector('.header__icon--cart');
    const headerHeadingLink = document.querySelector('.header__heading-link');
    const headerIcons = document.querySelector('.header__icons');
    if (cartIcon) {
      const hasCartBubble = cartIcon.querySelector('.cart-count-bubble');
      cartIcon.dataset.cartEmpty = hasCartBubble ? 'false' : 'true';
      headerHeadingLink.classList.toggle('header__heading-link--empty-cart', hasCartBubble);
      headerIcons.classList.toggle('header__icons--empty-cart', hasCartBubble);
    }
  }
  
  // Subscribe to cart update events
  if (typeof subscribe !== 'undefined') {
    subscribe('cart-update', function() {
      setTimeout(updateCartIconVisibility, 50);
    });
  }
  
  // Also listen for the cart:updated event
  document.addEventListener('cart:updated', function() {
    setTimeout(updateCartIconVisibility, 50);
  });
  
  // Run on page load
  setTimeout(updateCartIconVisibility, 100);

  } catch(e) { console.error(e); }
})();
})();
